import { RootState } from '@state/store';


export const selectAppLoading = (state: RootState) => state.app.loading;
